module.exports = __webpack_public_path__ + "static/ecosysteme-conferences-e67df1fbefb8cddedbb8531c5da49204.png";